import type { ComponentTheme } from '../types/component-theme';

import { SidebarNavItemVariants } from './constants/sidebar-nav-item';

const rootStyles =
    'items-center gap-2.5 rounded-(--border-radius-md) border-[0.063rem] border-transparent ' +
    'bg-(image:--button-light-surface) px-3 text-[0.8125rem] font-medium tracking-[-0.01em] ' +
    'text-(--text-button-light)';

export default {
    slots: {
        root: '',
        label: 'flex-1 overflow-hidden text-left text-ellipsis whitespace-nowrap'
    },
    variants: {
        variant: {
            [SidebarNavItemVariants.Group]: {
                root:
                    'group flex h-12 w-full cursor-pointer items-center gap-2.5 rounded-(--border-radius-md) ' +
                    'border-none bg-transparent px-3 font-inherit text-[0.8125rem] font-medium tracking-[-0.01em] ' +
                    'text-(--text-button-light) outline-none hover:text-(--text-button-light-strong) ' +
                    'focus-visible:text-(--text-button-light-strong)'
            },
            [SidebarNavItemVariants.Link]: {
                root:
                    'group relative flex h-12 w-full cursor-pointer ' +
                    rootStyles +
                    ' outline-none shadow-(--sidebar-nav-item-shadow) after:pointer-events-none after:absolute ' +
                    'after:inset-0 after:rounded-[inherit] after:opacity-0 ' +
                    'after:shadow-(--sidebar-nav-item-hover-shadow) after:transition-opacity after:duration-150 ' +
                    'after:ease-out after:content-[""] hover:bg-none hover:bg-(--border-glass) ' +
                    'hover:text-(--text-button-light-strong) hover:after:opacity-100 ' +
                    'focus-visible:text-(--text-button-light-strong) ' +
                    'focus-visible:shadow-(--sidebar-nav-item-focus-shadow)'
            },
            [SidebarNavItemVariants.Disabled]: {
                root:
                    'pointer-events-none relative flex h-12 w-full cursor-not-allowed ' +
                    rootStyles +
                    ' opacity-[0.4] filter-[grayscale(0.3)]'
            }
        },
        active: {
            true: {
                root: 'cursor-default font-semibold text-(--input-neumorphic-text)'
            }
        }
    },
    compoundVariants: [
        {
            variant: SidebarNavItemVariants.Link,
            active: true,
            class: {
                root:
                    'border-(--control-border-neumorphic) bg-none! bg-(--sidebar-active-background)! ' +
                    'shadow-[inset_0.188rem_0_0_var(--text-button-light-strong)]'
            }
        }
    ]
} satisfies ComponentTheme;
